import {LineupsWidgetMemberViewModel} from "../../../widgets/lineups-widget/models/lineups-widget.member.view-model";
import {observable, makeObservable, computed, override} from "mobx";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {LineupsMemberStatsViewModel} from "../../../domain/yard/lineups/lineups-member/stats/lineups-member.stats.view-model";
import {LineupsMemberDomainModel} from "../../../domain/yard/lineups/lineups-member/lineups-member-domain-model";
import {StatsCategoryViewModel} from "../../../domain/yard/lineups/statsCategory/stats-category.view-model";
import {StatsCategoryDomainModel} from "../../../domain/yard/lineups/statsCategory/stats-category.domain-model";
import {CompetitorPlayersStatsModuleStatsListViewModel} from "./competitor-players-stats-module.stats-list.view-model";
import {ATHLETE} from "../../../core/app/consts";
import type {ChartEventViewModel} from "../../../domain/full-game/models/chart-events/event/chart-event.view-model";

export class CompetitorPlayersStatsModulePlayerViewModel extends LineupsWidgetMemberViewModel {
  domainModel: LineupsMemberDomainModel;
  statsCategoryDomainModel: Array<StatsCategoryDomainModel>;
  shots: Array<ChartEventViewModel>
  allowPremiumData: Boolean;
  @observable selectedShotKey: String;

  constructor(model: LineupsMemberDomainModel, statsCategoryDomainModel: StatsCategoryDomainModel, shots: Array<ChartEventViewModel>, allowPremiumData: Boolean = true) {
    super(model);

    this.statsCategoryDomainModel = statsCategoryDomainModel;
    this.shots = shots;
    this.selectedShotKey = null;
    this.allowPremiumData = allowPremiumData;

    makeObservable(this);
  }

  @computed get selectedShot() {
    const selectedShot: ChartEventViewModel = this.shots?.find((shot: ChartEventViewModel) => shot.key === this.selectedShotKey) || null

    return selectedShot;
  }

  @computed get competitorId(): Number {
    return this.domainModel.competitorId;
  }

  @computed get entityLogoSize(): Number {
    const entityLogoSize = {
      desktop: COMPETITOR_PLAYER_STATS.DESIGN.PLAYER_LOGO_SIZE.desktop,
      mobile: COMPETITOR_PLAYER_STATS.DESIGN.PLAYER_LOGO_SIZE.mobile
    };

    return entityLogoSize;
  }

  @computed get badgeClassName(): String {
    const badgeClassName: String = `player_rating_container_${this?.rankingClassName}`

    return badgeClassName;
  }

  @computed get topStats(): Array<LineupsMemberStatsViewModel> {
    const topStats: Array<LineupsMemberStatsViewModel> = this.stats.filter((stat: LineupsMemberStatsViewModel) => stat.isTop);

    return topStats;
  }

  @computed get statsCategory(): Array<StatsCategoryViewModel> {
    const statsCategory: Array<StatsCategoryViewModel> = this.statsCategoryDomainModel?.map((stat: StatsCategoryViewModel) => new StatsCategoryViewModel(stat));

    return statsCategory;
  }

  @computed get playerStatsLists(): Array<CompetitorPlayersStatsModuleStatsListViewModel> {
    let selectedPlayerStats: Array<CompetitorPlayersStatsModuleStatsListViewModel> = [];

    this.hasStats && this.statsCategory?.forEach((statsCategory: StatsCategoryViewModel) => {
      const stats: Array<LineupsMemberStatsViewModel> = this.stats?.filter((stat: LineupsMemberStatsViewModel) => stat.categoryId === statsCategory.id && !stat.isTop)

      selectedPlayerStats.push(new CompetitorPlayersStatsModuleStatsListViewModel(stats, statsCategory, this.position?.id));
    })

    const sortedPlayerStats: Array<CompetitorPlayersStatsModuleStatsListViewModel> = selectedPlayerStats.sort((a: CompetitorPlayersStatsModuleStatsListViewModel, b: CompetitorPlayersStatsModuleStatsListViewModel) => a.order - b.order);

    return sortedPlayerStats;
  }

  @computed get enableAthleteLinkModel(): Boolean {
    const enableAthleteLinkModel: Boolean = this.athleteId > 0 && !ATHLETE.BLOCKED_SPORT_TYPES_ATHLETES.includes(this.sport?.id);

    return enableAthleteLinkModel;
  }

  @override get hasShotChart() {
    return this.domainModel.hasShotChart || this.shots?.length > 0;
  }
}
